import { render } from "./snow.vue?vue&type=template&id=54c36f32"
import script from "./snow.vue?vue&type=script&lang=js"
export * from "./snow.vue?vue&type=script&lang=js"

import "./snow.vue?vue&type=style&index=0&id=54c36f32&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__